<template functional>
  <div>
    <svg-icon v-if="props.svg && props.icon" :icon-class="props.icon" />
    <i v-else-if="props.icon" :class="props.icon"></i>
    <span v-if="props.title" slot="title">{{ props.title }}</span>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    svg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>